/* eslint-disable import/order */
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalSystemSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalSystemSettings.tsx';
import { notFoundEntrypoint } from '@jira/spa-apps__error-pages-not-found/src/notFoundEntrypoint.entrypoint.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { globalSettingsPerformanceUserSetupInsightsRoute } from '@jira/router-routes__admin-pages-performance-routes/src/globalSettingsPerformanceUserSetupInsightsRoute.tsx';
import { conditionalPostOfficeJiraTopBannerResource } from '@jira/router-resources__post-office/src/conditionalPostOfficeJiraTopBannerResource.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { userSetupInsightsEntryPoint } from '@jira/admin-pages__performance/src/userSetupInsightsPageEntrypoint.entrypoint.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';

const userSetupInsightsPageEntrypoint = createPageEntryPoint({
	main: userSetupInsightsEntryPoint,
});

const notFoundPageEntrypoint = createPageEntryPoint({
	main: notFoundEntrypoint,
});

export const globalSettingsPerformanceUserSetupInsightsRouteEntry: Route = createEntry(
	globalSettingsPerformanceUserSetupInsightsRoute,
	() => ({
		group: 'global-settings',

		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalSystemSettings,
			menuId: MenuIdSettings,
		},

		resources: [
			...getNavigationResources(),
			navigationSidebarGlobalResource,
			conditionalPostOfficeJiraTopBannerResource,
		],

		forPaint: [LazyAtlassianNavigation],

		canTransitionIn: () => fg('enable_jira_apm_m2'),

		entryPoint: () => {
			if (!fg('enable_jira_apm_m2')) {
				return notFoundPageEntrypoint;
			}
			return userSetupInsightsPageEntrypoint;
		},

		bifrost: {
			bifrostGroup: 'shell-only',
			enabled: true,
		},
	}),
);
